import React, { Component } from 'react';
import { HashRouter, Routes, Route, Link } from 'react-router-dom';
import AntCardLayout from '../AntCardLayout';
import AntSystemLogin from '../AntSystemLogin';

export default (props) => (
    <AntCardLayout>
        <HashRouter>
            <Routes>
                <Route element={() => <AntSystemLogin appInfo={props.appInfo} appAssets={props.appAssets} onLogin={props.onLogin} />} />
            </Routes>
        </HashRouter>
    </AntCardLayout>
);
